
export const domainBroadcastChannel = new BroadcastChannel('wf_domain_channel');
export const domainBroadcastId = Math.floor(Math.random() * 10000) + 1;
